import React from 'react';
import {Modal, ModalHeader, ModalBody} from 'reactstrap';

const ProfileModal = (props) => {
  const {openModal, modalTitle, className,modalToggleHandler} = props;

  return (
    <>
      <Modal
        isOpen={openModal}
        className={className}
        centered={true}        
      >
        {modalTitle && (
          <ModalHeader
            toggle={() => {
              modalToggleHandler();
            }}
          >
            {modalTitle}
          </ModalHeader>
        )}
        <ModalBody>{props.children}</ModalBody>
      </Modal>
    </>
  );
};

export default ProfileModal;
